import { createPinia } from 'pinia'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue'
import router from './router'
import { registerGuards } from './router/guards'
import { vPerm } from './directives/perm'
import './styles/index.css'
import 'element-plus/dist/index.css'

const app = createApp(App)

app.use(createPinia())
registerGuards(router)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.directive('perm', vPerm)

app.mount('#app')
